import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "../reducers/rootReducer";
import { applyMiddleware, compose } from "redux";
import { thunk } from 'redux-thunk';

const middleware = [thunk];
const enhancers = [];

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

const store = configureStore({
  reducer: {
    applicationState: rootReducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false, 
    })
  }
}, composedEnhancers);

export default store;
